import type { Catalog } from "./catalog.js";

// Catalan. Emergency register, plain language.
// Completed in E3 — full coverage of en.ts (enforced by test/i18n-coverage.test.ts).
export const ca: Catalog = {
  "app.name": "Beacon",
  // Onboarding — Promise
  "onboarding.promise.tagline": "Veïns que avisen veïns.",
  "onboarding.promise.proof.corroboration": "×14 corroboracions de mitjana per alerta",
  "onboarding.promise.proof.time": "menys de 90 s fins a una alerta corroborada",
  "onboarding.promise.proof.nosignup": "0 comptes, números de telèfon o registres necessaris",
  "onboarding.promise.continue": "Comença",
  "onboarding.promise.restore": "Recupera la meva identitat",
  "onboarding.promise.step": "BENVINGUDA",
  // Onboarding — Permissions (JIT-honest)
  "onboarding.perms.step": "PAS 2 / 3",
  "onboarding.perms.title": "Com et demana permís Beacon",
  "onboarding.perms.location": "La ubicació només serveix per vigilar la teva zona. T'ho demanem el primer cop que centres el mapa.",
  "onboarding.perms.notifications": "Les notificacions porten les alertes. T'ho demanem el primer cop que les actives.",
  "onboarding.perms.background": "L'actualització en segon pla manté les alertes a temps. Opcional, es demana en context.",
  "onboarding.perms.later": "Configura-ho més tard",
  "onboarding.perms.continue": "Continua",
  // Onboarding — Home
  "onboarding.home.step": "PAS 3 / 3",
  "onboarding.home.title": "On és la teva zona?",
  "onboarding.home.radius": "Radi de vigilància",
  "onboarding.home.km": "{n} km",
  "onboarding.home.pickHint": "Mou el mapa perquè el pin marqui aquest lloc.",
  "onboarding.home.confirm": "Vigila aquesta zona",
  "onboarding.home.browse": "De moment, només explora",
  "onboarding.home.locating": "Cercant la teva ubicació…",
  "onboarding.home.located": "Marcador a la teva ubicació actual — ajusta’l si cal.",
  "onboarding.home.unavailable": "Ubicació no disponible — mou el mapa fins a casa teva.",
  // Now tab — status
  "now.meta": "{place} · {radius} km",
  "now.meta.ago": "fa {m} min",
  "now.meta.justNow": "ara mateix",
  "now.meta.none": "encara sense esdeveniments",
  "now.meta.net": "xarxa {v}",
  "now.meta.netDown": "xarxa —",
  "now.meta.info.title": "Què volen dir aquests números",
  "now.meta.info.radius": "{radius} km — el radi de vigilància de la teva zona.",
  "now.meta.info.area": "{area} — quan va arribar el darrer esdeveniment de la teva zona (incident, propagació, temps o ajuda).",
  "now.meta.info.net": "xarxa {net} — quan es va ingerir el darrer esdeveniment a tota la xarxa, de qualsevol font o veí a Europa. Si això avança i el teu no, la xarxa va bé i simplement no té res de nou per a tu.",
  "now.meta.info.feeds": "Fonts darrere del que veus: {feeds}.",
  "now.place.default": "la teva zona",
  "region.unsupported.title": "Fora de la regió cartografiada",
  "region.unsupported.body": "Encara no hi ha tessel·les de mapa per a aquesta ubicació.",
  "now.status.step": "ARA",
  "now.status.allClear": "Tot tranquil.",
  "now.status.stayAware": "Estigues atent.",
  "now.status.nearby.fire": "Foc a prop.",
  "now.status.nearby.flood": "Inundació a prop.",
  "now.status.nearby.earthquake": "Terratrèmol notat.",
  "now.status.nearby.conflict": "Perill a prop.",
  "now.status.nearby.other": "Risc a prop.",
  "now.status.nearby.traffic": "Tall de trànsit a prop.",
  "now.status.nearby.storm": "Tempesta a prop.",
  "now.status.nearby.snow": "Neu a prop.",
  "now.status.nearby.ice": "Gel a les carreteres a prop.",
  "now.status.nearby.heat": "Avís de calor extrem.",
  "now.status.nearby.fog": "Boira densa a prop.",
  "now.status.nearby.hazmat": "Alerta de materials perillosos a prop.",
  "now.status.nearby.outage": "Tall de subministrament a prop.",
  "now.status.sub": "{distance} km · {place}",
  "now.status.sub.allClear": "Res actiu dins del teu radi de vigilància.",
  // Now tab — community strip
  "now.community.neighbors": "{n} veïns",
  "now.community.watching": "VIGILANT",
  "now.community.helpers": "{n} ajudants",
  "now.community.helpersLabel": "A PROP",
  "now.community.median": "<90s",
  "now.community.medianLabel": "FINS A ALERTA CORROBORADA",
  "now.community.corroborated": "×{n}",
  "now.community.corroboratedLabel": "CORROBORAT",
  // Now tab — activity + report
  "now.activity.title": "A PROP",
  "now.activity.empty": "Res a prop ara mateix.",
  "now.pulse.live": "Xarxa activa — darrer esdeveniment fa {s} s",
  "now.pulse.quiet": "Xarxa en calma des de fa {m} min",
  "now.pulse.unreachable": "No es pot contactar amb el relay",
  "now.pulse.area": "La teva zona: darrer avís fa {m} min",
  "now.pulse.areaNone": "La teva zona: encara sense avisos",
  "now.zone.addHere": "Ets fora dels teus llocs vigilats — afegir aquí com a zona?",
  "now.activity.corroboration": "CORROBORAT ×{n}",
  "now.group.areas": "{n} zones",
  "now.group.expand": "Mostra les zones",
  "now.report.button": "Informa",
  "now.recenter": "Recentrar a la meva posició",
  "now.fitAll": "Mostra tots els llocs",
  "now.raw.toggle": "Informes en brut",
  "now.raw.list.title": "Informes ({n})",
  "now.raw.list.more": "+{n} més",
  "now.raw.detail": "{hazard} · via {feed} · {time}",
  "now.report.title": "Informe",
  "now.report.unverified": "Informe sense verificar — encara no corroborat",
  "now.report.event": "Esdeveniment",
  "now.report.response": "Resposta",
  "now.report.severity": "Gravetat",
  "now.report.observed": "Observat",
  "now.report.source": "Font",
  "now.warning.viewSource": "Mostra l'avís complet ↗",
  // Report sheet — corroborate mode
  "report.corroborate.title": "Corrobora",
  "report.corroborate.q": "És el {hazard} a prop de {place}?",
  "report.corroborate.yes": "Sí, també ho veig",
  "report.corroborate.no": "No, això és diferent",
  // Report sheet — full flow
  "report.title": "Informa d'un risc",
  "report.step.what": "Què passa?",
  "report.step.where": "On?",
  "report.step.howbad": "Com de greu?",
  "report.where.here": "Aquí (la teva zona)",
  "report.where.honesty": "Es comparteix com el teu barri, no la teva adreça.",
  "report.where.pick": "Tria un punt al mapa",
  "report.where.pickHint": "Arrossega el mapa perquè el marcador quedi al lloc.",
  "report.where.current": "Ubicació actual",
  "report.where.home": "Casa",
  "report.where.pin": "Marca al mapa",
  "report.where.selected": "Informa a",
  "report.where.locating": "Localitzant…",
  "report.where.locateFailed": "No s'ha pogut obtenir la teva ubicació — informant des de casa.",
  "report.note.placeholder": "Afegeix una línia (opcional)",
  "report.next": "Següent",
  "report.back": "Enrere",
  "report.submit": "Envia l'informe",
  "report.cancel": "Cancel·la",
  "report.severity.label": "Gravetat",
  // Report sheet — confirmation
  "report.done.title": "Enviat",
  "report.done.body": "Ara és visible per als veïns. Les alertes salten quan altres ho corroboren.",
  "report.done.close": "Fet",
  "report.error": "No s'ha pogut enviar — pots tornar-ho a provar.",
  // Hazards (controlled vocab)
  "hazard.fire": "Foc",
  "hazard.flood": "Inundació",
  "hazard.earthquake": "Terratrèmol",
  "hazard.conflict": "Perill",
  "hazard.other": "Risc",
  "hazard.traffic": "Trànsit", "hazard.storm": "Tempesta", "hazard.snow": "Neu",
  "hazard.ice": "Gel", "hazard.heat": "Calor", "hazard.fog": "Boira",
  "hazard.hazmat": "Materials perillosos", "hazard.outage": "Tall de subministrament",
  // Chrome
  "tab.now": "Ara",
  "tab.help": "Ajuda",
  "tab.you": "Tu",
  "tab.talk": "Conversa",
  "tab.beacon": "Configuració de Beacon",
  "beacon.tab.step": "CONFIGURACIÓ",
  "beacon.tab.title": "Beacon",
  // Talk tab
  "talk.scope.area": "La meva zona",
  "talk.scope.region": "Regió ampliada",
  "talk.region.size": "Mida de la regió: ~{km} km",
  "talk.band.area": "a la teva zona",
  "talk.band.region": "la teva regió · ~{km} km",
  "talk.band.distant": "llunyà",
  "talk.you": "Tu",
  "talk.empty": "Encara no hi ha missatges. Saluda la teva zona.",
  "zone.checking": "Comprovant la teva zona…",
  "zone.stalled": "Encara sense connexió amb la xarxa — continuem provant…",
  "zone.progress.windows": "historial {done}/{total}",
  "zone.progress.attempts": "intent {done}/{total}",
  "zone.retry": "Torna-ho a provar",
  "talk.placeholder.locked": "🔒 missatge no disponible",
  "talk.composer.placeholder": "Escriu a la teva zona…",
  "talk.composer.send": "Envia",
  "talk.new.count": "{n} nous ↓",
  "talk.zone.home": "Home",
  "talk.zone.nearby": "Nearby",
  "talk.compose.noCell": "Waiting for this place's location…",
  "banner.simulation": "SIMULACIÓ",
  "locale.switch": "Idioma",
  // Alert receipt — toast/takeover (C4)
  "alert.toast.new": "{hazard} informat a prop",
  "alert.toast.escalation": "El {hazard} a prop s'ha agreujat",
  "alert.toast.inPath": "El {hazard} ara avança cap a tu",
  "alert.toast.reAlert": "{hazard} a prop — actualització",
  "alert.toast.allClear": "Tot tranquil a prop de {place}",
  "alert.toast.sub": "{distance} km · {place}",
  "alert.toast.tap": "Toca per veure detalls i passos de seguretat",
  "alert.toast.more": "+{n} més",
  "alert.severity.info": "AVÍS",
  "alert.severity.warning": "ADVERTÈNCIA",
  "alert.severity.critical": "CRÍTIC",
  "alert.takeover.title": "{hazard} — actua ara",
  "alert.takeover.sub": "{distance} km de {place}",
  "alert.takeover.steps": "PASSOS DE SEGURETAT",
  "alert.takeover.details": "Veure tots els detalls",
  "alert.takeover.dismiss": "Descarta",
  "alert.takeover.dismissNext": "Descarta i veure el següent · {n} més",
  // IncidentDetail (C4)
  "incident.detail.metrics.corroborated": "×{n}",
  "incident.detail.reports.title": "Informes darrere d’això ({n})",
  "incident.detail.metrics.corroboratedLabel": "CORROBORAT",
  "incident.detail.metrics.first": "{ago}",
  "incident.detail.metrics.firstLabel": "PRIMER INFORME",
  "incident.detail.metrics.spread": "{status}",
  "incident.detail.metrics.spreadLabel": "PROPAGACIÓ",
  "incident.detail.spread.moving": "Avança ~{speed} km/h",
  "incident.detail.spread.stationary": "Estacionari",
  "incident.detail.spread.dissipating": "Amainant",
  "incident.detail.spread.unknown": "—",
  "incident.detail.steps": "PASSOS DE SEGURETAT",
  "incident.detail.directions": "Com arribar-hi",
  "incident.detail.share": "Comparteix",
  "incident.detail.help": "Puc ajudar",
  "incident.detail.helpSoon": "La coordinació d'ajuda arribarà aviat.",
  "incident.detail.flag": "Informa d'un problema amb aquesta alerta",
  "incident.detail.flagSoon": "Els informes de problemes arribaran aviat.",
  "incident.detail.back": "Enrere",
  "incident.detail.away": "{hazard} — a {n} km",
  "incident.detail.ago.min": "fa {n} min",
  "incident.detail.ago.hr": "fa {n} h",
  "incident.detail.ago.now": "ara mateix",
  // IncidentDetail — details block (origin / how bad / status) + corroborate
  "incident.detail.meta.title": "DETALLS",
  "incident.detail.meta.origin": "Origen",
  "incident.detail.meta.severity": "Gravetat",
  "incident.detail.meta.status": "Estat",
  "incident.detail.origin.crowd": "Comunitat",
  "incident.detail.origin.authority": "Oficial",
  "incident.severity.1": "Lleu",
  "incident.severity.2": "Greu",
  "incident.severity.3": "Molt greu",
  "incident.status.open": "Actiu",
  "incident.status.sustained": "En curs",
  "incident.status.closing": "Disminuint",
  "incident.status.closed": "Tancat",
  "incident.detail.seeIt": "Jo també ho veig",
  "incident.detail.seeItDone": "Gràcies: el teu informe s'ha afegit.",
  "incident.detail.tab.safety": "Seguretat",
  "incident.detail.tab.details": "Detalls",
  "incident.detail.tab.actions": "Accions",
  "incident.detail.helpBrowse": "Veure peticions d'ajuda",
  // Safety steps — tone-invariant, per hazard (GUI §3)
  "safety.fire.1": "Marxa aviat — no esperis a veure flames.",
  "safety.fire.2": "Vés contra el vent i amunt del fum.",
  "safety.fire.3": "Emporta't aigua, medicació i el telèfon.",
  "safety.fire.4": "Si quedes atrapat, busca terreny net o un edifici.",
  "safety.flood.1": "Vés a un lloc més alt ara.",
  "safety.flood.2": "Mai caminis ni condueixis per aigua en moviment.",
  "safety.flood.3": "Talla el corrent si l'aigua puja dins de casa.",
  "safety.flood.4": "Allunya't de rius, desguassos i ponts.",
  "safety.earthquake.1": "Ajup-te, protegeix-te i aguanta fins que pari el sotrac.",
  "safety.earthquake.2": "Allunya't de finestres i mobles pesants.",
  "safety.earthquake.3": "Després del sotrac, comprova fuites de gas i danys.",
  "safety.earthquake.4": "Espera rèpliques — prepara't per protegir-te de nou.",
  "safety.conflict.1": "Allunya't del perill i busca refugi.",
  "safety.conflict.2": "Acota't i mantén parets sòlides entre tu i el perill.",
  "safety.conflict.3": "Comparteix el teu estat amb algú de confiança.",
  "safety.conflict.4": "Segueix les indicacions d'emergència locals.",
  "safety.other.1": "Allunya't del risc immediat.",
  "safety.other.2": "Avisa els veïns que potser no ho han vist.",
  "safety.other.3": "Segueix les indicacions d'emergència locals.",
  "safety.traffic.1": "Redueix la velocitat i augmenta la distància.",
  "safety.traffic.2": "Segueix els senyals i fusiona't aviat al carril.",
  "safety.traffic.3": "Considera una ruta alternativa.",
  "safety.storm.1": "Queda't a dins i allunyat de les finestres.",
  "safety.storm.2": "Evita viatjar fins que passi.",
  "safety.storm.3": "Assegura els objectes solts a l'exterior.",
  "safety.storm.4": "Allunya't d'arbres i línies elèctriques.",
  "safety.snow.1": "Evita desplaçaments no essencials.",
  "safety.snow.2": "Abriga't bé i mantén el telèfon carregat.",
  "safety.snow.3": "Desbloqueja les sortides i comprova els veïns.",
  "safety.ice.1": "Ves amb compte a les carreteres i camins.",
  "safety.ice.2": "Redueix la velocitat i frena amb suavitat.",
  "safety.ice.3": "Usa calçat amb agarre.",
  "safety.heat.1": "Beu aigua sovint.",
  "safety.heat.2": "Queda't a l'ombra o en llocs frescos.",
  "safety.heat.3": "Evita l'esforç al migdia.",
  "safety.heat.4": "Comprova l'estat de gent gran i vulnerable.",
  "safety.fog.1": "Redueix la velocitat i usa llum de creuer.",
  "safety.fog.2": "Mantén una distància extra.",
  "safety.fog.3": "Evita els avançaments.",
  "safety.hazmat.1": "Entra en un local i tanca finestres i ventilacions.",
  "safety.hazmat.2": "Evita la zona afectada.",
  "safety.hazmat.3": "Segueix les instruccions oficials.",
  "safety.outage.1": "Estalvia bateria del telèfon.",
  "safety.outage.2": "Usa llanternes, no espelmes.",
  "safety.outage.3": "Comprova els veïns que puguin necessitar ajuda.",
  "offline.strip": "FORA DE LÍNIA · ÚLTIMA SINC. {time}",
  // Help tab — need types (controlled vocab)
  "need.medical": "Mèdica",
  "need.rescue": "Rescat",
  "need.transport": "Transport",
  "need.shelter": "Aixopluc",
  "need.supplies": "Subministraments",
  "need.hands": "Mans",
  "need.other": "Altres",
  // Help tab — status block (GUI §4)
  "help.status.step": "AJUDA",
  "help.status.some": "{n} persones necessiten ajuda a prop.",
  "help.status.one": "1 persona necessita ajuda a prop.",
  "help.status.none": "No hi ha sol·licituds obertes a prop.",
  "help.status.sub": "Més a prop: {need} · {distance} km",
  "help.status.subNone": "Aquí veuràs les peticions obertes de la teva zona.",
  // Helper mode card
  "help.helper.toggle": "Puc ajudar",
  "help.helper.intro": "Ofereix ajuda als veïns a prop teu.",
  "help.helper.tagsLabel": "En què pots ajudar?",
  "help.helper.ttlLabel": "Durant quant de temps?",
  "help.helper.ttl.today": "Avui",
  "help.helper.ttl.week": "Aquesta setmana",
  "help.helper.ttl.incident": "Durant aquest incident",
  "help.helper.area": "Només la teva zona — ubicació aproximada, mai la teva adreça.",
  "help.helper.register": "Registra la disponibilitat",
  "help.helper.registered": "Estàs disponible per ajudar. Et mostrarem les peticions a prop.",
  "help.helper.tierUnknown": "CONFIANÇA · creix a mesura que ajudes i et avalen",
  // Requests near you (matcher A7 push, private SSE)
  "help.nearby.title": "Sol·licituds a prop teu",
  "help.nearby.toast": "Algú a prop necessita {need}",
  "help.nearby.empty": "Encara no hi ha coincidències: se't notificarà.",
  "help.offer.toast": "Algú s'ha ofert a ajudar",
  "help.accept.error": "Encara no s'ha pogut acceptar: s'està sincronitzant aquesta persona. Torna-ho a provar d'aquí un moment.",
  // Open requests list
  "help.list.title": "PETICIONS OBERTES",
  "help.list.empty": "No hi ha peticions obertes a la teva zona.",
  "help.list.verified": "◆",
  // Request detail + offer/accept (GUI §4)
  "help.detail.back": "Enrere",
  "help.detail.needLabel": "Necessita {need}",
  "help.detail.urgencyLabel": "URGÈNCIA",
  "help.detail.location": "Només zona aproximada",
  "help.detail.honesty": "L'adreça exacta només es comparteix si accepten la teva oferta.",
  "help.detail.offer": "Ofereix ajuda",
  "help.detail.submitOffer": "Envia l'oferta",
  "help.detail.notePlaceholder": "Afegeix una nota (opcional)",
  "help.detail.etaPlaceholder": "Temps d'arribada en minuts (opcional)",
  "help.detail.offersTitle": "OFERTES",
  "help.detail.offersEmpty": "Encara no hi ha ofertes. Els veïns veuran aquesta petició.",
  "help.detail.accept": "Accepta",
  "help.detail.accepted": "Acceptada",
  "help.detail.acceptCaveat": "Acceptar comparteix la teva ubicació exacta amb aquesta persona: no se'n verifica la identitat i no es pot desfer.",
  "help.detail.offerSent": "Oferta enviada. T'avisarem si l'accepten.",
  // Create request sheet
  "help.create.button": "Demana ajuda",
  "help.create.title": "Demana ajuda",
  "help.create.step.need": "Què necessites?",
  "help.create.step.what": "Què cal?",
  "help.create.step.urgency": "Quina urgència?",
  "help.create.headlinePlaceholder": "Una línia — què necessites?",
  "help.create.peoplePlaceholder": "Quantes persones?",
  "help.create.urgencyLabel": "URGÈNCIA",
  "help.create.next": "Següent",
  "help.create.back": "Enrere",
  "help.create.submit": "Publica la petició",
  "help.create.error": "No s'ha pogut publicar. Torna-ho a provar.",
  "help.create.done.title": "Petició publicada.",
  "help.create.done.body": "Els veïns a prop ja la poden veure i oferir ajuda.",
  "help.create.done.close": "Fet",
  // My activity
  "help.activity.title": "LA TEVA ACTIVITAT",
  "help.activity.mine": "La teva petició",
  "help.activity.helping": "Estàs ajudant",
  "help.activity.offered": "Has ofert ajuda",
  "help.activity.pending": "Encara no és a la xarxa",
  "help.screen.resolvedDone": "Resolt — marcat com a fet.",
  "help.screen.resolvedCancelled": "Aquesta sol·licitud s'ha cancel·lat.",
  "help.screen.loading": "S'està carregant la sol·licitud…",
  "help.activity.activeTitle": "ACTIVES",
  "help.activity.resolvedTitle": "RESOLTES",
  "help.activity.badge.done": "Fet",
  "help.activity.badge.cancelled": "Cancel·lada",
  "help.activity.badge.active": "Activa",
  // Coordination thread (GUI §4, §6)
  "help.thread.back": "Enrere",
  "help.thread.title": "Coordinació",
  "help.thread.precise": "Ubicació compartida",
  "help.thread.preciseSelf": "La teva ubicació compartida",
  "help.thread.heartbeat": "{name} · {state}",
  "help.thread.composePlaceholder": "Missatge…",
  "help.thread.send": "Envia",
  "help.thread.done": "Fet",
  "help.thread.cantMake": "No hi puc anar",
  "help.thread.you": "Tu",
  "help.thread.requester": "Qui demana",
  "help.thread.helper": "Ajudant · {id}",
  "help.thread.resend": "Reenviar",
  "help.thread.empty": "Coordineu-vos aquí. Els missatges estan xifrats per a tothom en aquesta sol·licitud.",
  "help.thread.openMap": "Obre el mapa ↗",
  "help.confirm.cancel": "Cancel·la",
  "help.confirm.done.title": "Marcar com a resolta?",
  "help.confirm.done.body": "S'avisa qui ajuda i passa a Resoltes.",
  "help.confirm.done.confirm": "Marca feta",
  "help.confirm.cant.title": "Retirar la teva ajuda?",
  "help.confirm.cant.body": "La sol·licitud es reobre per a altres persones a prop.",
  "help.confirm.cant.confirm": "Retira",
  "help.status.chip.open": "Oberta",
  "help.status.chip.accepted": "Acceptada",
  "help.status.chip.enroute": "De camí",
  "help.status.chip.arrived": "Ha arribat",
  "help.status.chip.partial": "Parcial",
  "help.status.chip.done": "Feta",
  "help.status.chip.cancelled": "Cancel·lada",
  // Lifecycle step labels (numbered-steps)
  "help.lifecycle.open": "Oberta",
  "help.lifecycle.offered": "Oferta",
  "help.lifecycle.accepted": "Acceptada",
  "help.lifecycle.enroute": "En camí",
  "help.lifecycle.arrived": "Ha arribat",
  "help.lifecycle.done": "Fet",
  // You tab (GUI §5)
  "you.step": "TU",
  "you.title": "Tu i la teva configuració",
  // Location & alerts
  "you.loc.title": "UBICACIÓ I ALERTES",
  "you.loc.home": "Zona de casa",
  "you.loc.setHome": "Defineix la ubicació de casa",
  "you.loc.coords": "Coordenades",
  "you.loc.change": "Canvia la zona de casa",
  "you.loc.setHomeHint": "Tria una zona de casa per veure el mapa i rebre alertes del que tens a prop.",
  "you.loc.radius": "Radi de vigilància",
  "you.loc.km": "{n} km",
  "you.loc.quiet": "Hores de silenci",
  "you.loc.quietValue": "{start}:00 – {end}:00",
  "you.loc.quietOff": "Desactivat",
  "you.loc.quietToggle": "Silencia les alertes no crítiques de nit",
  "you.loc.autoDismiss": "Descartar avisos després de",
  "you.loc.autoDismiss.seconds": "{n}s",
  "you.loc.autoDismiss.never": "Romandre fins a descartar",
  "you.loc.minsev": "Gravetat mínima per alertar",
  "you.loc.addPlace": "Afegeix un altre lloc",
  "you.loc.addCurrent": "Fes servir la ubicació actual",
  "you.loc.liveFollow": "Segueix la meva ubicació",
  "you.loc.liveFollowHint": "T'avisa de perills on ets mentre Beacon està obert. Gasta més bateria; desactivat per defecte.",
  "you.loc.liveFollowUnavailable": "L'accés a la ubicació està desactivat. Activa'l al navegador per seguir la teva ubicació.",
  "you.loc.keepAwake": "Mantén la pantalla encesa en seguir",
  "you.loc.keepAwakeHint": "Manté la pantalla activa durant el seguiment en directe perquè no es perdi cap alerta. Si ho desactives, un dispositiu adormit no et pot avisar: una limitació de les aplicacions web.",
  "you.sound.title": "So d'alerta",
  "you.sound.hint": "Reprodueix un to breu amb la veu que has triat quan apareix una alerta. Desactivat fins que l'activis; sempre en silenci durant les hores de silenci.",
  "you.sound.preview": "Reprodueix una mostra",
  "you.loc.travelRadius": "Radi en ruta",
  "you.loc.places": "LLOCS VIGILATS",
  "you.loc.placeUnnamed": "Lloc desat",
  "you.loc.removePlace": "Treu",
  "now.watched.title": "Altres llocs vigilats",
  "now.watched.alert": "Incendi a prop de {place}",
  "you.loc.editPlace": "Edita",
  "you.loc.placeName": "Nom",
  "you.loc.homeName": "Nom de casa",
  "you.loc.moveUp": "Mou amunt",
  "you.loc.moveDown": "Mou avall",
  // Voice (supporter-locked)
  "you.voice.title": "VEU",
  "you.voice.intro": "Tria com et parla Beacon.",
  "you.voice.official": "Oficial",
  "you.voice.human": "Humana",
  "you.voice.dark": "Humor negre",
  "you.voice.deadpan": "Impassible",
  "you.voice.nonna": "Àvia",
  "you.voice.preview.official": "Incendi forestal informat 3 km al nord. Corroborat per 14 veïns.",
  "you.voice.preview.human": "Hi ha un foc just al nord teu — els teus veïns també el veuen.",
  "you.voice.preview.dark": "Foc al nord. Tan bon moment com qualsevol per estrenar les sabatilles.",
  "you.voice.preview.deadpan": "Foc al nord. Anotat.",
  "you.voice.preview.nonna": "Hi ha un foc just al nord, estimat — vés-hi ara, t'ho dic de debò.",
  // Trust
  "you.trust.title": "CONFIANÇA",
  "you.trust.tier": "El teu nivell",
  "you.trust.tierUnknown": "— alimentat pel projector (D2)",
  "you.trust.how": "Com creix: antiguitat del compte, informes confirmats i avals.",
  "you.trust.factor.age": "Antiguitat del compte",
  "you.trust.factor.confirmed": "Informes confirmats",
  "you.trust.factor.vouches": "Avals",
  "you.trust.factorValue": "— alimentat pel projector (D2)",
  "you.trust.vouch": "Avala un veí",
  "you.trust.vouchHint": "Comparteix aquest enllaç en persona amb algú de confiança.",
  "you.trust.vouchers": "Els teus avaladors",
  "you.trust.vouchersEmpty": "— alimentat pel projector (D2)",
  "you.trust.backup": "Còpia i rotació de claus",
  "you.trust.export": "Descarrega el meu fitxer de recuperació",
  "you.trust.exportHint": "Aquest fitxer és el teu compte. Guarda'l en un lloc segur i privat.",
  "you.trust.import": "Restaura des d'un fitxer de recuperació",
  "you.trust.rotate": "Rota les meves claus",
  "you.trust.rotateHint": "Substitueix les teves claus de signatura. Descarrega després un fitxer de recuperació nou.",
  "you.trust.rotated": "Claus rotades. Descarrega ara el teu nou fitxer de recuperació.",
  "you.trust.importBad": "Aquest fitxer no és un fitxer de recuperació de Beacon vàlid.",
  "you.trust.importOk": "Fitxer de recuperació acceptat. S'utilitzarà el proper cop que obris l'app.",
  "you.trust.capability.direct": "Els teus informes alerten la teva zona directament.",
  "you.trust.capability.needsConfirm": "Ara mateix un veí ha de confirmar el teu informe abans d'alertar la zona.",
  "you.trust.capability.full": "Els teus informes ja tenen pes total. Les alertes grans encara necessiten que alguns veïns les confirmin — així és com Beacon es manté fiable.",
  "you.trust.progress.confirmed": "Amb {confirmed} informe(s) confirmat(s) més, els teus informes tindran més pes.",
  "you.trust.progress.days": "Continua usant Beacon uns {days} dia(es) més per guanyar reputació.",
  // Privacy
  "you.privacy.title": "PRIVADESA",
  "you.privacy.consentTitle": "El que has acceptat",
  "you.consent.alerts": "Rebre alertes de la meva zona",
  "you.consent.helperAvailability": "Compartir la meva disponibilitat per ajudar",
  "you.consent.preciseLocationRelease": "Alliberar la ubicació precisa quan accepti una petició",
  "you.consent.publicMetrics": "Contribuir a mètriques públiques anònimes",
  "you.privacy.export": "Exporta les meves dades",
  "you.privacy.exportHint": "Una còpia portàtil de tot el que hi ha en aquest dispositiu.",
  "you.privacy.erase": "Esborra'm",
  "you.privacy.eraseHint": "Esborrat criptogràfic: les teves claus es destrueixen i les teves dades s'apaguen a tot arreu.",
  // Seguretat i privadesa — què protegeix el xat d'ajuda i els seus límits.
  "you.safety.title": "SEGURETAT I PRIVADESA",
  "you.safety.intro": "Què es protegeix quan demanes o ofereixes ajuda, i on són els límits.",
  "you.safety.toggle": "Com es protegeix la teva seguretat",
  "you.safety.e2ee.h": "Els missatges estan xifrats d'extrem a extrem",
  "you.safety.e2ee.d": "Només tu i la persona amb qui et coordines els podeu llegir: ni Beacon ni el relé.",
  "you.safety.location.h": "La teva ubicació exacta queda privada fins que acceptes",
  "you.safety.location.d": "Qui ajuda només veu la teva zona aproximada. Tan bon punt acceptes algú, només aquesta persona rep la teva ubicació precisa.",
  "you.safety.metadata.h": "La xarxa pot veure que t'estàs coordinant",
  "you.safety.metadata.d": "Les teves paraules i la ubicació exacta estan ocultes, però sí que es veu que estàs rebent ajuda, la teva zona aproximada i el moment. Tracta el teu barri com a públic.",
  "you.safety.identity.h": "No es verifica la identitat de qui ajuda",
  "you.safety.identity.d": "Qualsevol pot oferir ajuda amb qualsevol nom. Comparteix dades sensibles només quan tinguis clar amb qui tractes.",
  "you.safety.irrevocable.h": "Compartir la teva ubicació precisa no es pot desfer",
  "you.safety.irrevocable.d": "Un cop acceptes, aquella persona conserva la ubicació que has compartit. No hi ha marxa enrere.",
  "you.safety.forwardSecrecy.h": "Els missatges antics depenen de la seguretat del teu dispositiu",
  "you.safety.forwardSecrecy.d": "Beacon encara no fa servir una clau nova per a cada missatge, així que una clau robada podria exposar xats passats. Mantén el telèfon bloquejat.",
  "you.safety.retention.h": "Els missatges caduquen, però no els pots esborrar",
  "you.safety.retention.d": "Els missatges de coordinació desapareixen sols al cap d'un temps. Encara no hi ha esborrat manual missatge a missatge.",
  // Erase confirmation (grave)
  "you.erase.title": "Esborrar-te de Beacon?",
  "you.erase.body": "Això destrueix les claus que desbloquegen tot el que has compartit. Els informes i missatges que ja són als telèfons dels veïns no es poden retirar, però tota la resta s'apaga per sempre. Això no es pot desfer.",
  "you.erase.confirmLabel": "Escriu ESBORRAR per confirmar",
  "you.erase.confirmWord": "ESBORRAR",
  "you.erase.cancel": "Mantén el meu compte",
  "you.erase.confirm": "Esborra'm",
  "you.erase.done": "La teva petició d'esborrat està signada i en camí. Adéu.",
  // Support Beacon
  // App
  "you.app.title": "APP",
  "you.app.language": "Idioma",
  "you.app.notifications": "Notificacions",
  "you.app.notificationsOn": "Activades",
  "you.app.notificationsOff": "Desactivades",
  "you.notif.enabled": "Notificacions activades. Rebràs avisos encara que el Beacon estigui tancat.",
  "you.notif.denied": "Les notificacions estan bloquejades. Permet-les a la configuració del navegador per rebre avisos amb el Beacon tancat.",
  "you.notif.unsupported": "Aquest navegador no pot mostrar notificacions amb el Beacon tancat. Les alertes dins l'app continuen funcionant.",
  "you.notif.nopush": "Notificacions permeses, però l'enviament encara no està configurat en aquest servidor. Les alertes dins l'app continuen funcionant.",
  "you.notif.subfail": "Notificacions permeses, però aquest dispositiu no ha pogut activar l'enviament. Les alertes dins l'app continuen funcionant.",
  "you.notif.subfail.noservice": "Notificacions permeses, però aquest dispositiu no té servei d'enviament (p. ex. sense Google Play). Les alertes dins l'app funcionen; per a les de segon pla usa Chrome o la futura app de Beacon.",
  "you.notif.dismissed": "Cap avís amb el Beacon tancat fins que permetis les notificacions. Activa-les quan vulguis.",
  "you.app.about": "Quant a Beacon",
  "you.app.version": "Versió pilot",
  // Flags & appeals (only if non-empty)
  "you.flags.title": "ELS TEUS AVISOS I RECURSOS",
  // E2 moderation — flag sheet
  "flag.title": "Informa d'un problema",
  "flag.intro": "Els avisos són privats. Mai es diu a l'autor qui ha avisat.",
  "flag.reason.falseReport": "Fals o enganyós",
  "flag.reason.spam": "Brossa",
  "flag.reason.harassment": "Assetjament",
  "flag.reason.dangerousAdvice": "Consell perillós",
  "flag.reason.harvestAttempt": "Intent de recollir ubicacions",
  "flag.reason.doxxing": "Doxxing / dades personals",
  "flag.reason.illegal": "Contingut il·legal",
  "flag.reason.other": "Una altra cosa",
  "flag.submit": "Envia l'avís",
  "flag.done": "Gràcies — els moderadors ho revisaran.",
  "flag.error": "No s'ha pogut enviar. Torna-ho a provar.",
  // E2 moderation — You transparency surface
  "you.flags.empty": "Aquí no hi ha res. Cap acció sobre els teus informes.",
  "you.flags.actionLabel": "Acció sobre la teva activitat",
  "you.flags.weight": "Es mostra més avall a la classificació",
  "you.flags.reversible": "Això és reversible i temporal. Pots presentar un recurs.",
  "you.flags.appeal": "Recórrer això",
  "you.flags.expires": "Caduca el {date}",
  // E2 moderation — appeal sheet
  "appeal.title": "Recurs",
  "appeal.intro": "Explica per què s'hauria de revertir. Un moderador ho revisa.",
  "appeal.statement.placeholder": "Per què és incorrecte?",
  "appeal.submit": "Envia el recurs",
  "appeal.done": "Recurs enviat. Veuràs el resultat aquí.",
  "appeal.error": "No s'ha pogut enviar el recurs. Torna-ho a provar.",
  // E9 incident detail — trend / freshness / source / advanced (Task 3)
  "incident.detail.meta.lastConfirmed": "Última confirmació",
  "incident.detail.meta.wind": "Vent",
  "incident.detail.meta.trend": "Tendència",
  "incident.detail.meta.sources": "Fonts",
  "incident.detail.trend.rising": "Intensificant-se",
  "incident.detail.trend.steady": "Estable",
  "incident.detail.trend.falling": "Minvant",
  "incident.detail.worsening": "Empitjorant",
  "incident.detail.adv.title": "Avançat",
  "incident.detail.adv.intensity": "Potència radiativa",
  "incident.detail.adv.mw": "{n} MW",
  "incident.detail.adv.peak": "(pic {n} MW)",
  "incident.detail.adv.trendAxes": "Detall de la tendència",
  "incident.detail.adv.weight": "Pes de corroboració",
  "incident.detail.adv.identities": "Autoritats confirmadores",
  "incident.detail.adv.axis.rising": "↑",
  "incident.detail.adv.axis.steady": "→",
  "incident.detail.adv.axis.falling": "↓",
  "incident.detail.wind": "{speed} km/h de {dir}",
  "compass.n": "N",
  "compass.ne": "NE",
  "compass.e": "E",
  "compass.se": "SE",
  "compass.s": "S",
  "compass.sw": "SO",
  "compass.w": "O",
  "compass.nw": "NO",
  "incident.source.nasa-firms": "NASA FIRMS",
  "incident.source.fogos.pt": "fogos.pt",
  "incident.source.anepc": "ANEPC",
  "now.activity.confirmedAgo": "confirmat {ago}",
  "now.activity.worsening": "▲ intensificant-se",
  // Install pointer (M3)
  "you.get.title": "INSTAL·LA BEACON AL MÒBIL",
  "you.get.body": "Instal·la Beacon per rebre alertes encara que estigui tancat.",
  "you.get.cta": "Obtén Beacon",
  "install.title": "Instal·la Beacon al mòbil",
  "install.desktop.intro": "Beacon t'avisa de perills propers encara que la pàgina estigui tancada.",
  "install.desktop.scan": "Escaneja per obrir Beacon al mòbil.",
  "install.ios.intro": "Instal·la Beacon per rebre alertes encara que estigui tancat.",
  "install.ios.step.share": "Toca el botó Comparteix.",
  "install.ios.step.add": "Tria «Afegeix a la pantalla d'inici».",
  "install.ios.step.open": "Obre Beacon des de la pantalla d'inici.",
  "install.ios.note": "Sense botiga d'aplicacions, res per baixar.",
  "install.android.intro": "Instal·la Beacon per rebre alertes encara que estigui tancat.",
  "install.android.install": "Instal·la Beacon",
  "install.android.apk": "APK autoallotjat (sense Google)",
  "install.hint.title": "Instal·la Beacon",
  "install.hint.body": "Rep alertes encara que Beacon estigui tancat.",
  "install.hint.cta": "Instal·la",
  "install.hint.dismiss": "Descarta",
  // You-tab cleanup (field card + disclosures)
  "you.card.trusted": "Veí de confiança",
  "you.card.building": "Guanyant confiança",
  "you.card.neighbor": "Veí",
  "you.card.watch": "vigilància de {n} km",
  "you.card.noHome": "Sense zona de casa definida",
  "you.loc.alertDetail": "Ajusta les alertes",
  "you.loc.livePosition": "Posició en directe",
  "you.loc.level.off": "Desactivat",
  "you.loc.level.info": "Info",
  "you.loc.level.warning": "Avís",
  "you.loc.level.critical": "Crític",
  "you.trust.howToggle": "Com funciona la confiança",
  "you.trust.keysToggle": "Claus i recuperació",
  "you.privacy.dataToggle": "Les teves dades",
  "you.card.id": "ID de Beacon",
  "you.loc.homeTitle": "CASA I LLOCS",
  "you.loc.alertsTitle": "ALERTES",
  "you.loc.removeConfirm": "Treure?",
  "you.loc.cancel": "Cancel·la",
  // Advanced — raw-report layer (power-user opt-in)
  "you.raw.title": "Informes bruts (avançat)",
  "you.raw.toggle": "Mostra informes individuals al mapa",
  "you.raw.warning": "Els informes bruts tenen molt més volum que els incidents confirmats i consumeixen més dades i bateria. Activar igualment?",
  "you.raw.depth.label": "Fins on carregar",
  "you.raw.depth.off": "Només en directe",
  "you.raw.depth.shallow": "Superficial",
  "you.raw.depth.medium": "Mitjà",
  "you.raw.depth.deep": "Profund",
  // Advanced — spread-cone debug cells (authoritative H3 overlay)
  "you.cone.title": "Cel·les del con (avançat)",
  "you.cone.toggle": "Mostra les cel·les exactes del motor d'alertes",
  "you.cone.helper": "Superposa les cel·les H3 autoritatives que el motor d'alertes utilitza per decidir qui és a la trajectòria d'un perill: útil per comprovar per què va arribar o no una alerta.",

  "commons.card.title": "El comú",
  "commons.card.thisPeriod": "Aquest període",
  "commons.card.runRate": "Cost recurrent enfront de les aportacions",
  "commons.card.cumulative": "Històric",
  "commons.card.oneTime": "Puntual (p. ex. desenvolupament)",
  "commons.card.yourCost": "La teva part justa fins ara",
  "commons.card.yourGiven": "Has aportat",
  "commons.card.operatorStated": "declarat per l'operador",
  "commons.card.chipIn": "Aportar",
  "commons.card.chippedIn": "Ja has aportat aquest mes — gràcies.",
  "commons.card.need": "Beacon va necessitar {amount} aquest mes per avisar-te.",
  "commons.card.viewTransparency": "Veure transparència",
  "commons.card.deficit": "Dèficit",
  "commons.card.surplus": "Superàvit",
  "commons.card.empty": "Encara no hi ha activitat del comú.",
  "commons.chipIn.title": "Aporta al comú",
  "commons.chipIn.pickToken": "Tria què enviar",
  "commons.chipIn.amount": "Import (opcional)",
  "commons.chipIn.getAddress": "Obtén l'adreça",
  "commons.chipIn.address": "Envia a aquesta adreça",
  "commons.chipIn.copy": "Copia l'adreça",
  "commons.chipIn.copied": "Copiada",
  "commons.chipIn.deadline": "Paga en {min} min perquè se't acrediti. Els pagaments tardans també ajuden el comú, però no es mostraran a la teva targeta.",
  "commons.chipIn.oneClick": "Paga amb la cartera connectada",
  "commons.chipIn.noWallet": "No s'ha detectat cap cartera al navegador: escaneja o enganxa l'adreça.",
  "commons.chipIn.sent": "Transacció enviada",
  "commons.chipIn.error": "No s'ha pogut obtenir una adreça. Torna-ho a provar.",
  "commons.chipIn.intro": "Una aportació puntual per als costos de funcionament d'aquesta instància — en cadena, sense registre.",
  "commons.chipIn.network": "Envia a {network}",
  "commons.chipIn.wrongChain": "Envia només en aquesta xarxa: els fons en una altra cadena no es poden detectar.",
  "commons.chipIn.afterTitle": "Després d'enviar",
  "commons.chipIn.afterDetect": "El teu dipòsit es detecta automàticament a la cadena: no has de fer res més.",
  "commons.chipIn.afterAppear": "Quan la xarxa ho confirmi (normalment un o dos minuts), apareixerà al comú i a la teva targeta si has pagat dins del termini.",
  "commons.chipIn.done": "Fet",
  "commons.chipIn.close": "Tanca",
  "commons.received": "Aportació rebuda. Gràcies!",
  "commons.chipIn.waiting": "Esperant el teu dipòsit a la cadena…",
  "commons.chipIn.receivedTitle": "Aportació rebuda",
  "commons.chipIn.receivedBody": "Gràcies per aportar: ja és al llibre del comú.",
  "commons.privacy.hidden": "Ocult per a tothom",
  "commons.privacy.public": "Ocult en públic, vist breument per aquesta instància",
  "commons.privacy.custodial": "El teu banc/proveïdor ho veu",
  "commons.transparency.title": "Transparència del comú",
  "commons.transparency.intro": "Calculat completament a partir d'esdeveniments signats al firehose. Qualsevol pot reproduir-ho de manera independent.",
  "commons.transparency.series": "Cost recurrent enfront de les aportacions, per període",
  "commons.transparency.oneTimeSeries": "Costos puntuals, per període",
  "commons.transparency.projection": "Aquest període (estimació, prorrateig)",
  "commons.transparency.history": "Historial fins al gènesi",
  "commons.transparency.basis": "Base del denominador",
  "commons.transparency.reproduce": "Reprodueix-ho des del firehose: cada dada és un esdeveniment signat de cost o aportació.",
  "commons.transparency.colCost": "Cost recurrent",
  "commons.transparency.colContrib": "Aportacions",
  "commons.transparency.colNet": "Net",
  "commons.transparency.colOneTime": "Puntual",
  "commons.transparency.estimate": "estimació",
};
